import React from 'react'
import WorldCupStagesAdmin from './WorldCupStagesAdmin'
import WorldCupTeamsAdmin from './WorldCupTeamsAdmin'
import WorldCupMatchesAdmin from './WorldCupMatchesAdmin'
import WorldCupChampionAdmin from './WorldCupChampionAdmin'
import WorldCupLeaderboardAdmin from './WorldCupLeaderboardAdmin'
import './WorldCupAdmin.css'

const SECTION_COMPONENTS = {
  stages: WorldCupStagesAdmin,
  teams: WorldCupTeamsAdmin,
  matches: WorldCupMatchesAdmin,
  champion: WorldCupChampionAdmin,
  leaderboard: WorldCupLeaderboardAdmin,
}

export default function WorldCupAdmin({
  section = 'stages',
  initialEditMatchId = null,
  onInitialEditHandled,
}) {
  const SectionComponent = SECTION_COMPONENTS[section] || WorldCupStagesAdmin

  return (
    <div className="worldcup-admin-page">
      <SectionComponent
        initialEditMatchId={initialEditMatchId}
        onInitialEditHandled={onInitialEditHandled}
      />
    </div>
  )
}
